import React from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface DisableProgramProps {
  programName: string
  isOpen: boolean
  onClose(): void
  onConfirm(): void
}

export const DisableRewardProgramModal: React.FC<DisableProgramProps> = (
  props: DisableProgramProps
) => {
  return (
    <Dialog open={props.isOpen} onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Disable Program</DialogTitle>
        </DialogHeader>
        <p>
          Are you sure you want to disable <strong>{props.programName}</strong>?<br></br> <br></br>{' '}
          Clients currently in an active cycle will see the program widget replaced with a{' '}
          <strong>"Program Ended"</strong> state for 14 days. Clients who have already claimed their
          reward this cycle are unaffected.
        </p>
        <DialogFooter>
          <Button onClick={() => props.onClose()}>Cancel</Button>
          <Button onClick={props.onConfirm} variant={'destructive'}>
            Disable Program
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
